import {
    IonBackButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonLabel,
    IonListHeader,
    IonPage,
    IonTitle,
    IonToast,
    IonToolbar,
    useIonViewDidEnter
} from '@ionic/react';
import {
    arrowBack,
    folderOutline
} from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { MessageContext } from '../../../../../contexts/MessageContext';
import './MenuFiscal.css';

type Props = {
    abrirMenu: boolean;
};

const MenuFiscal: React.FC<Props> = (props: Props) => {
    const history = useHistory();
    const [showToast, setShowToast] = useState(false);
    const [textToast, setTextToast] = useState("");

    const [acessos] = useState<any>(JSON.parse(window.localStorage.getItem("acessos") || '{}'));
    const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
    const { nomeMenu, setNomeMenu } = useContext(MessageContext);

    useIonViewDidEnter(() => {
        setEsconderMenu(true);
        setNomeMenu("");
    });

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar color="primary">
                    <IonButtons slot="start">
                        <IonBackButton icon={arrowBack} text='' />
                    </IonButtons>
                    <IonTitle slot="start">Fiscal</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent>

                <IonListHeader lines="full">NFC-e</IonListHeader>

                {/* <IonItem lines="none" button routerLink="/empresa/fiscalemissao" routerDirection="forward" detail
                    hidden={acessos?.fiscal != 'leitura' && acessos?.fiscal != 'edicao'}>
                    <IonIcon color='medium' slot="start" icon={receiptOutline} />
                    <IonLabel>Emitir NFC-e Avulsa</IonLabel>
                </IonItem> */}

                <IonItem lines="none" button routerLink="/empresa/fiscalhistorico" routerDirection="forward" detail
                    hidden={acessos?.fiscal != 'leitura' && acessos?.fiscal != 'edicao'}>
                    <IonIcon color='medium' slot="start" icon={folderOutline} />
                    <IonLabel>Histórico de Notas</IonLabel>
                </IonItem>

                <IonToast
                    isOpen={showToast}
                    position="middle"
                    onDidDismiss={() => setShowToast(false)}
                    message={textToast}
                    duration={3000}
                />
            </IonContent>
        </IonPage>
    );
};

export default MenuFiscal;
